// ProtectedRoute.jsx
import { Navigate, Outlet } from 'react-router-dom'

import { useProfileUser } from '@/hooks/useUser'

export function ProtectedRoute({ allowedRoles }: { allowedRoles: ('ADMIN' | 'USER')[] }) {
  const profile = useProfileUser()

  const isAllowed = allowedRoles.some(role => profile.roles.includes(role))

  if (!isAllowed) {
    return <Navigate replace to="/" />
  }

  return <Outlet />
}
